import React from 'react';
import './packages.scss';

import {Button, HeadingElement, PackageCard} from 'components';
import {useMediaQuery} from 'react-responsive'


import PLAN_DISASTER from 'assets/icons/education_packages/plan_disaster.svg'
import PLAN_EDUCATION from 'assets/icons/education_packages/plan_education.svg'
import PLAN_LIST from 'assets/icons/education_packages/plan_list.svg'
import PLAN_MEETING from 'assets/icons/education_packages/plan_meeting.svg'
import PLAN_REVIEW from 'assets/icons/education_packages/plan_review.svg'
import PLAN_SEMINAR from 'assets/icons/education_packages/plan_seminar.svg'
import {ReactComponent as ELEMENT_01} from 'assets/business-education-assets/elements/be_element_02.svg'

import PLANNING_IMAGE from 'assets/business-education-assets/Planning_lady.png';
// import GROW_IMAGE from 'assets/business-education-assets/growing_business_image.png';
import GROW_IMAGE from 'assets/business-education-assets/be_grow_image.png';
import START_IMAGE from 'assets/business-education-assets/starting_business_image.png';
import {useNavigate} from "react-router-dom";


const planList: { icon: any, text: string }[] = [
    {
        icon: PLAN_LIST,
        text: "Business Plan checklist"
    },
    {
        icon: PLAN_REVIEW,
        text: "Business Plan Consulting and review"
    },
    {
        icon: PLAN_MEETING,
        text: "Identifying target audience"
    },
    {
        icon: PLAN_DISASTER,
        text: "Disaster & Risk Management"
    },
    {
        icon: PLAN_SEMINAR,
        text: "Seminars, Webinars, Workshops etc..."
    },
    {
        icon: PLAN_EDUCATION,
        text: "Education Material"
    }
];

const startList: any[] = [
    {
        icon: PLAN_EDUCATION,
        text: "Business Registration Process"
    },
    {
        icon: PLAN_EDUCATION,
        text: "Marketing Strategies"
    },
    {
        icon: PLAN_EDUCATION,
        text: "Content Creation, posters, websites etc..."
    },
    {
        icon: PLAN_EDUCATION,
        text: "Business Taxes Registration Assistance"
    },
    {
        icon: PLAN_EDUCATION,
        text: "Seminars, Webinars & Workshops etc..."
    },
    {
        icon: PLAN_EDUCATION,
        text: "Education Material"
    }
];

const growList: { icon: any, text: string }[] = [
    {
        icon: PLAN_MEETING,
        text: "Market research & Penetration"
    },
    {
        icon: PLAN_REVIEW,
        text: "Product Development & Diversification"
    },
    {
        icon: PLAN_LIST,
        text: "Importing & Exporting"
    },
    {
        icon: PLAN_MEETING,
        text: "Diversify Offer Lineup"
    },
    {
        icon: PLAN_REVIEW,
        text: "Strategic Partnership"
    },
    {
        icon: PLAN_LIST,
        text: "Leverage Global Platforms"
    },
];

const Packages = () => {
    const navigate = useNavigate();

    const smDesktop = useMediaQuery({
        query: '(min-width: 1200px)'
    })
    return (
        <div className={'packages'} id={'packages'}>
            <ELEMENT_01 className={'packages_element_01'}/>
            <ELEMENT_01 className={'packages_element_01_02'}/>
            <div className={'packages_wrapper max'}>
                <div className="packages_wrapper_plan" id={'packages_plan'}>
                    <div className="packages_wrapper_plan_left">
                        <HeadingElement/>
                        <h1>Planning A Business</h1>
                        <p>Planning a business has never been easier. With our help, you can smoothly transition through
                            the planning stages in order to get your business started.</p>
                        {!smDesktop && <img id={'section_image'} src={PLANNING_IMAGE} alt=""/>}

                        <span>How do we help you plan?</span>
                        <div className="packages_wrapper_plan_left_cards">
                            {planList.map(({icon, text}, index) => (
                                <PackageCard key={text + index} icon={icon} text={text}/>
                            ))}
                        </div>

                    </div>
                    <div className="packages_wrapper_plan_right">
                        <p>We provide industry specific and industry standard information to our member, strengthening
                            their possibility of being successful. </p>
                        {smDesktop && <img src={PLANNING_IMAGE} alt=""/>}
                        <p>Markets might pose to be competitive at times, so we will help you in identifying ways through
                            which you cause provide your services or develop products that stand outing the market. </p>
                        <Button text={'Become a Member'} type={'primary'} onclick={() => navigate('/registration')}/>
                    </div>
                </div>

                <div className="packages_wrapper_start" id={'packages_start'}>
                    <div className="packages_wrapper_start_left">
                        <HeadingElement/>
                        <h1>Starting A Business</h1>
                        <p>When you're on your own, starting a business is a multi-step process that can be
                            overwhelming. That's why we are here to help you simplify the process to start your business
                            and achieve success.</p>
                        {!smDesktop && <img id={'section_image'} src={START_IMAGE} alt=""/>}

                        {smDesktop && <img src={START_IMAGE} alt=""/>}
                        <p>Our supportive team of experts will help you along your journey towards successfully
                            completing all the required stages in getting your business off it's feet. </p>

                        {smDesktop &&
                        <Button text={'Become a Member'} type={'primary'} onclick={() => navigate('/registration')}/>}
                    </div>
                    <div className="packages_wrapper_start_right">
                        <span>How do we help you start?</span>
                        <div className="packages_wrapper_start_right_cards">
                            {startList.map(({icon, text}, index) => (
                                <PackageCard key={text + index} icon={icon} text={text}/>

                            ))}
                        </div>
                        {!smDesktop &&
                        <Button text={'Become a Member'} type={'primary'} onclick={() => navigate('/registration')}/>}
                    </div>
                </div>

                <div className="packages_wrapper_grow" id={'packages_grow'}>
                    <div className="packages_wrapper_grow_left">
                        <HeadingElement/>
                        <h1>Growing A Business</h1>
                        {/*{!smDesktop && <img id={'section_image'} src={GROW_IMAGE} alt=""/>}*/}
                        <p>Growing and expanding a business can be very challenging, however, we have tested and proven
                            strategies to achieve business growth.</p>
                        <span>How do we help you Grow?</span>
                        <div className="packages_wrapper_grow_left_cards">
                            {growList.map(({icon, text}, index) => (
                                <PackageCard key={text + index} icon={icon} text={text}/>
                            ))}
                        </div>
                        <p>Our growth services are accessible to new startup businesses and even larger companies
                            looking for ways to enhance their services and grow. Join us today and get started.</p>

                        <Button text={'Become a Member'} type={'primary'} onclick={() => navigate('/registration')}/>
                    </div>
                    <div className="packages_wrapper_grow_right">
                        <img src={GROW_IMAGE} alt=""/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Packages;

